import { Button, Col, Form, Row, message, DatePicker } from 'antd';
import React from 'react';
import moment from 'moment';
import { reportService } from '_services';

function StockInOutSummarySearch(props) {
  const [form] = Form.useForm();
  let dateFilter = false;
  let fromDate = null;
  let toDate = null;

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = '';
    searchParams += searchParams.indexOf('?') === -1 ? '?' : '&';
    if (values.requestDateRange) {
      searchParams += `fromDate=${encodeURIComponent(
        moment(values.requestDateRange[0]).startOf('day').format('YYYY-MM-DD')
      )}&toDate=${moment(values.requestDateRange[1])
        .startOf('day')
        .format('YYYY-MM-DD')}`;
      fromDate = moment(values.requestDateRange[0])
        .startOf('day')
        .format('YYYY-MM-DD');
      toDate = moment(values.requestDateRange[1])
        .startOf('day')
        .format('YYYY-MM-DD');
      dateFilter = true;
    } else {
      searchParams += `fromDate=${encodeURIComponent(
        moment().format('YYYY-MM-DD')
      )}&toDate=${moment().format('YYYY-MM-DD')}`;
      dateFilter = false;
    }

    reportService
      .getStockInOutSummary(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          fromDate,
          toDate,
          dateFilter,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([]);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout='vertical'
      className='search-form'
    >
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item name='requestDateRange' label='Date Range'>
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                'This Month': [
                  moment().startOf('month'),
                  moment().endOf('month'),
                ],
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}></Col>
        <Col span={6} style={{ textAlign: 'right' }}>
          <div>
            <Button type='primary' htmlType='submit'>
              Search
            </Button>
            <Button
              style={{ margin: '0 8px' }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default StockInOutSummarySearch;
